var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.error)?_c('div',[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"preloader-wrapper"},[_c('vpreloader',{attrs:{"width":"2","size":"64"}})],1):_vm._e(),_vm._v(" "),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }